'use strict';

exports.__esModule = true;
exports['default'] = property;

var _validators = require('../../utils/validators');

function property(name, value) {
  return function (target) {
    (0, _validators.validateClass)(target, name);

    Object.defineProperty(target.prototype, name, {
      value: value
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/others/property.js
// module id = 35
// module chunks = 1